<template>
    <h1 class="mb-1 fs-5">
        <slot name="title"></slot>
    </h1>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
            <li class="breadcrumb-item active" aria-current="page" >
                <slot name="title-link"></slot>
            </li>
        </ol>
    </nav>
</template>